export interface IPaymentEventDashboardState {
  readonly paymentEventDashboard?: any;
  readonly paymentEventDashboardConfig?: any;
}

export interface IPaymentEventDashboardSelector extends IPaymentEventDashboardState {
  readonly paymentEventDashboard?: any;
  readonly paymentEventDashboardConfig?: any;
}

export enum PaymentEventDashboardActionTypes {
  UPDATE_PAYMENT_EVENT_DASHBOARD_CONFIG = 'redux-app/payment-event-dashboard/UPDATE_PAYMENT_EVENT_DASHBOARD_CONFIG',
}

export default null;
